import { useCallback, useEffect, useRef, useState } from 'react';
import { parrainageAPI } from '@/lib/api';
import { useParrainageRefresh } from '@/hooks/useParrainageRefresh';

const EMPTY = { dashboard: null, leaderboard: [], activity: [], objectives: [] };

export function useParrainageInsights({ period, isAdmin, isParrain, effectiveVp }) {
    const enabled = !isAdmin || !!effectiveVp || isParrain;
    const key = JSON.stringify([period, isAdmin, isParrain, effectiveVp]);
    const currentKey = useRef(key);
    currentKey.current = key;
    const sequence = useRef(0);
    const [state, setState] = useState({ key, ...EMPTY, loading: false, error: null });

    const load = useCallback(async () => {
        const request = ++sequence.current;
        if (!enabled) return;
        setState(previous => ({ ...(previous.key === key ? previous : EMPTY), key, loading: true, error: null }));
        const params = { ...(period !== 'all' ? { period } : {}), ...(isAdmin && effectiveVp ? { vp_id: effectiveVp } : {}) };
        try {
            const [d, l, a, o] = await Promise.all([
                parrainageAPI.getDashboard(params), parrainageAPI.getLeaderboard(params),
                parrainageAPI.getActivity(isAdmin && effectiveVp ? { vp_id: effectiveVp } : {}),
                isParrain ? Promise.resolve({ data: { objectives: [] } }) : parrainageAPI.getObjectives(isAdmin ? effectiveVp : undefined),
            ]);
            if (request !== sequence.current || currentKey.current !== key) return;
            setState({ key, dashboard: d.data, leaderboard: l.data.leaderboard || [], activity: a.data.events || [],
                objectives: o.data.objectives || [], loading: false, error: null });
        } catch {
            if (request !== sequence.current || currentKey.current !== key) return;
            setState(previous => ({ ...previous, loading: false, error: 'Actualisation impossible. Réessayez.' }));
        }
    }, [key, enabled, period, isAdmin, isParrain, effectiveVp]);

    useEffect(() => () => { sequence.current += 1; }, [key]);
    useParrainageRefresh(load, enabled);
    const current = state.key === key && enabled ? state : { ...EMPTY, loading: enabled, error: null };
    return { ...current, load };
}